<template>
  <div class="container">
    <div style="display:flex;">
      <div class="title">
        <!--标签-->
        <div>
          <div class="name">
            {{ testPaperTitleInfoVO.testPaperName }}
          </div>
        </div>
        <div class="text">
          <div>
            共{{ testPaperTitleInfoVO.testTotalNum }}道题 共{{
              testPaperTitleInfoVO.testTotalScore
            }}分
          </div>
        </div>
      </div>
      <!--标签-->
      <div class="score-value" v-if="testPaperTitleInfoVO.reviewStatus == '03'">
        {{ testPaperTitleInfoVO.studentScore }}分
      </div>
    </div>
    <div
      v-for="(questionItem,
      testPagerReadIndex) in quetionList"
      :key="testPagerReadIndex"
      style="width: 60%; margin: 10px"
    >
      <div class="top-zero bottom-zero" style="margin-top: -10px">
        <div>
          <!--标签-->
          <div class="pa-0">
            <div
              class="content"
              style="
                margin-top: 25px;
                margin-left: 27px;
                text-align: start;
                font-weight: bold;
              "
            >
              {{ testPagerReadIndex + 1 }}.{{
                questionItem.questionContent
              }}
              <span class="questionScore">
                ({{ questionItem.questionScore }}分)
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="file-box"> -->
          <!--标签-->
          <!-- <div > -->
            <!-- <div v-for="(item, index) in questionItem.itemVOList" :key="index" class="inner-box">
              <video v-if="item.fileType == '02'" class="video" :src="item.fileUrl" controls/>
              <viewer>
                <img
                  v-if="item.fileType =='01'"
                  :data-source="item.fileUrl"
                  :src="item.fileUrl? item.fileUrl:require('@/assets/avatar.jpg')"
                  class="image"
                />
              </viewer>
            </div> -->
          <!-- </div> -->
        <!-- </div> -->
        <div class="file-box" >
          <div v-for="(item, index) in questionItem.itemVOList" :key="index" style="display: inline-block;">
            <div v-if="item.fileType == '02'" style="width: 450px;display: inline-block; height:auto">
              <!--标签-->
              <!-- 视频 -->
              <div v-if="item.fileType == '02'">
                <video v-if="item.fileType == '02'" class="video" :src="item.fileUrl" controls />
              </div>
            </div>
          </div>
        </div>

        <div class="file-box" >
          <div v-for="(item, index) in questionItem.itemVOList" :key="index" style="display: inline-block;">
            <div v-if="item.fileType == '01'" style="display: inline-block; height:auto; width: 220px;">
              <!-- 标签 -->
              <!-- 图片 -->
              <div v-if="item.fileType == '01'">
                <viewer>
                  <img
                    v-if="item.fileType =='01'"
                    :data-source="item.fileUrl"
                    :src="item.fileUrl? item.fileUrl:require('@/assets/avatar.jpg')"
                    class="image"              
                  />
                </viewer>
              </div>
            </div>
          </div>
        </div>


        <div v-if="testPaperTitleInfoVO.reviewStatus == '03'">
          <!--标签-->
          <div class="pa-0 score-content">
              得分：<span style="margin-left:5px;color:red;">{{questionItem.score}}</span>
          </div>
        </div>
      </div>
    </div>
    <!--老师评语 已批阅-->
    <div v-if="testPaperTitleInfoVO.reviewStatus == '03'">
      <div>
        <!--标签-->
        <div style="margin-top: 25px; margin-left: 20px; font-size: 18px;" >
          老师评语
        </div>
      </div>
      <div style="margin-left: 42px">
        <BInputTextArea style="height: 150px; width: 60%;" :disabled="true" v-model="testPaperTitleInfoVO.remarks"/>
      </div>
    </div>
    <!--按钮操作-->
    <div class="box box-btn">
      <BBtnPrimary :clicked="doBack" btn-txt="返回"/>
    </div>
  </div>
</template>
<script>
import { practiceDetail} from "@/api/stuTestPaper";
import BBtnPrimary from "../../components2/BBtnPrimary";
import BInputTextArea from "../../components2/BInputTextArea";
export default {
  components: {
    BBtnPrimary,
    BInputTextArea,
  },
  name: "StudentManagement",
  data: () => ({
    searchParam: {},
    snackbarText: "",
    quetionList: [],
    testPaperTitleInfoVO: {
      testPaperName: "",
      testTotalNum: 0,
      testTotalScore: 0,
      remarks: "",
      studentScore: 0,
    },
  }),
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const params = {
        studentTestPaperId: vm.$route.params.studentTestPaperId,
        releaseId: vm.$route.params.releaseId,
        classId: vm.$route.params.classId,
      };
      // 参数赋值
      if (
        params.releaseId !== undefined &&
        params.releaseId !== null &&
        params.releaseId !== ""
      ) {
          // 把不为空的参数存入缓存
          vm.$store.commit("SET_STU_TEST_PAPER_PRACTICE_PARAMS", params);
      }
      // 参数赋值 发布试卷的id
      if (
        vm.$store.state.stuTestPagerPractice_releaseId !== undefined &&
        vm.$store.state.stuTestPagerPractice_releaseId !== null &&
        vm.$store.state.stuTestPagerPractice_releaseId !== ""
      ) {
        vm.releaseId =
          vm.$store.state.stuTestPagerPractice_releaseId;
        vm.studentTestPaperId =
          vm.$store.state.stuTestPagerPractice_studentTestPaperId;  
        vm.classId =
          vm.$store.state.stuTestPagerPractice_classId;  
      }
      vm.getTestPagerDetail();
    });
  },
  methods: {
    // 点击详情
    getTestPagerDetail() {
      this.fetchData();
    },
    async fetchData() {
      const params = {
        classId: this.classId,
        releaseId: this.releaseId,
        studentTestPaperId: this.studentTestPaperId,
      };
      const data = await practiceDetail(params);
      console.log("****data************",data);
      this.quetionList = data.data.questionVOList;
      this.testPaperTitleInfoVO = data.data.testPaperTitleInfoVO;
    },
    
    doBack () {
      this.$router.push({
          name: "stu-homework-management",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  padding-top: 0px;
}
.bottom {
  padding-bottom: 0px;
}

.container {
  width: 100%;
  padding-top: 50px;
  align-items: center;
  flex-wrap: wrap;
}

.title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 65%;
}
.name {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 600;
  color: #333333;
}
.text {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.scoreContent {
  display: flex;
  flex-direction: row;
  margin-top: 50px;
  margin-bottom: 100px;
}
.score-text {
  margin-top: 7px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.score-value {
  font-size: 40px;
  font-family: Source Han Sans CN;
  font-weight: 600;
  color: red;
  text-align: left;
  margin-left: 40px;
  width: 35%;
}
.inner-line {
  display: flex;
  flex-direction: row;
}
.box-right {
  margin-left: 20px;
  margin-top: 20px;
}
.toalScore-text {
  margin-top: 5px;
}
.score_class {
  border: none;
  width: 100px;
  height: 20px;
  justify-content: flex-end;
  margin-right: 20px;
  margin-top: 10px;
}
.content {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.questionScore {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #b3bbbe;
}
.score-content {
  display: flex; 
  font-size: 16px;
  // justify-content: space-between;
  margin-left:30px
}
.video {
  width: 440px;
  height: 270px;
  background: #000000;
}
.image {
  width: 200px;
  height: 220px;
  margin: 5px 10px 0px 0px;
}
.box-btn {
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin-top: 20px;
  margin-left: 30px;
}
.file-box {
  // display: flex;
  // justify-content: flex-start;
  // max-height: 362px;
  // min-height: 0px;
  // margin: 10px 30px 20px 50px;
  // overflow: auto;
  // overflow-x: hidden;
  width: 930px;
}
.inner-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 5px 10px 0px 0px;
}

</style>
